import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Box,
    Container,
    Grid,
    Card,
    CardBody,
    Avatar,
    Heading,
    Text,
    VStack,
    HStack,
    Button,
    IconButton,
    Badge,
    Divider,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    useDisclosure,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Select,
    useColorModeValue,
    useColorMode,
    Spinner,
    Alert,
    AlertIcon,
    useToast,
    SimpleGrid,
    Image,
    Flex,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    GridItem,
    CardHeader,
    CardBody as ChakraCardBody,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useThemeContext } from '../../contexts/ThemeContext';
import { useApi } from '../../contexts/ApiContext';
import {
    CordeCommonModelsDtoUserprofileUserProfile as UserProfileDto,
    CordeCommonModelsDtoUserprofileAvatar as AvatarDto,
    CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest as SetDefaultUserProfileRequest,
    CordeCommonModelsDtoContactContact as ContactDto,
} from '@/api/generated/v1/api';
import { CachedAvatar } from '../../components/common/CachedAvatar';
import { decodeJWT } from '@/utils/jwt';
import { useContacts } from '../../hooks/useContacts';
import { ContactCard } from '../../components/contacts/ContactCard';
import axios from 'axios';

// Иконки
const EditIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    </svg>
);

const CameraIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 15.2c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4.4c.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4-1.4-.63-1.4-1.4.63-1.4 1.4-1.4z"/>
        <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
    </svg>
);

const SettingsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.43-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
    </svg>
);

const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
);

const ChevronLeftIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
    </svg>
);

const ChevronRightIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
    </svg>
);

const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
);

// Component for loading avatar images
const AvatarImage: React.FC<{
    avatar: AvatarDto;
    profileId: string;
    onClick?: () => void;
    [key: string]: any;
}> = ({ avatar, profileId, onClick, ...props }) => {
    const [imageUrl, setImageUrl] = useState<string>('/default-avatar.png');
    const [isLoading, setIsLoading] = useState(true);
    const { accessToken } = useAuth();

    useEffect(() => {
        const loadImageUrl = async () => {
            try {
                if (avatar.id) {
                    // Используем правильный подход для бинарных данных
                    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8080';
                    const avatarUrl = `${baseUrl}/api/v1/userprofile/${profileId}/avatars/${avatar.id}`;
                    
                    const response = await axios.get(avatarUrl, {
                        responseType: 'blob',
                        headers: {
                            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
                        },
                    });

                    const blob = new Blob([response.data], { 
                        type: response.headers['content-type'] || 'image/png' 
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    setImageUrl(objectUrl);
                }
            } catch (error) {
                console.error('Failed to load avatar image:', error);
                setImageUrl('/default-avatar.png');
            } finally {
                setIsLoading(false);
            }
        };

        loadImageUrl();
        
        // Cleanup blob URL when component unmounts
        return () => {
            if (imageUrl && imageUrl.startsWith('blob:')) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [avatar.id, profileId, accessToken]);

    if (isLoading) {
        return <Spinner size="sm" />;
    }

    return (
        <Image
            src={imageUrl}
            onClick={onClick}
            {...props}
        />
    );
};

export const ProfilePage: React.FC = () => {
    const { t } = useTranslation();
    const { accessToken } = useAuth();
    const { colorSchemes } = useThemeContext();
    const api = useApi();
    const toast = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const fileInputRef = useRef<HTMLInputElement>(null);

    // Font sizes
    const largeFontSize = "lg";

    // Spacings
    const mainSpacing = 8;
    const sectionSpacing = 6;
    const itemSpacing = 4;
    const smallSpacing = 2;

    // Sizes
    const iconSize = 4;
    const headerBottomMargin = 4;

    // Toast durations
    const successDuration = 3000;
    const errorDuration = 5000;
    const infoDuration = 3000;

    // State
    const [profile, setProfile] = useState<UserProfileDto | null>(null);
    const [editForm, setEditForm] = useState<UserProfileDto | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [error, setError] = useState('');
    const [isOwnProfile, setIsOwnProfile] = useState(false);
    const [isActiveProfile, setIsActiveProfile] = useState(false);
    const [profilesList, setProfilesList] = useState<UserProfileDto[]>([]);
    const [avatars, setAvatars] = useState<AvatarDto[]>([]);
    const [activeAvatarUrl, setActiveAvatarUrl] = useState<string>('/default-avatar.png');
    const [contacts, setContacts] = useState<ContactDto[]>([]);
    const [isLoadingContacts, setIsLoadingContacts] = useState(false);
    
    // Contact management
    const { listContacts } = useContacts();

    // Modal controls
    const { isOpen: isAvatarOpen, onOpen: onAvatarOpen, onClose: onAvatarClose } = useDisclosure();
    const { isOpen: isViewAvatarOpen, onOpen: onViewAvatarOpen, onClose: onViewAvatarClose } = useDisclosure();

    // Form state
    const [createForm, setCreateForm] = useState<Partial<UserProfileDto>>({
        first_name: '',
        last_name: '',
        display_name: '',
        bio: '',
        gender: '',
        language: 'ru',
        timezone: 'Europe/Moscow',
    });

    // Get userId from JWT
    const userId = React.useMemo(() => {
        if (!accessToken) return null;
        const payload = decodeJWT(accessToken);
        return payload?.sub || payload?.user_id || payload?.id || null;
    }, [accessToken]);

    useEffect(() => {
        loadProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, searchParams]);

    const loadContacts = async (profileId: string) => {
        setIsLoadingContacts(true);
        try {
            const contactsList = await listContacts('userprofile', profileId, undefined, undefined, undefined);
            setContacts(contactsList);
        } catch (err: any) {
            console.error('Failed to load contacts:', err);
            setContacts([]);
        } finally {
            setIsLoadingContacts(false);
        }
    };

    const loadProfile = async () => {
        setIsLoading(true);
        setError('');
        try {
            const profileIdFromUrl = searchParams.get('profile');
            let loadedProfile: UserProfileDto | null = null;
            if (profileIdFromUrl) {
                // Load another user's profile
                const response = await api.UserprofileApi.getUserProfile(profileIdFromUrl);
                if (!response.data.profile) throw new Error('Profile not found');
                loadedProfile = response.data.profile;
            } else if (userId) {
                // Load default profile for current user
                const response = await api.UserprofileApi.getDefaultUserProfile(userId);
                if (!response.data.profile) throw new Error('Profile not found');
                loadedProfile = response.data.profile;
            }
            if (!loadedProfile) throw new Error('Profile not found');
            setProfile(loadedProfile);
            setIsOwnProfile(loadedProfile.user_id === userId);
            setIsActiveProfile(loadedProfile.is_default || false);

            // Load contacts for the profile
            await loadContacts(loadedProfile.id!);

            // Don't load avatars automatically - they will be loaded lazily when needed
        } catch (err: any) {
            setError('Failed to load profile');
            setProfile(null);
        } finally {
            setIsLoading(false);
        }
    };

    // Lazy loading of avatars - only when needed
    const loadAvatarsIfNeeded = async (profileId: string) => {
        if (avatars.length === 0) {
            await loadAvatars(profileId);
        }
    };

    const loadAvatars = async (profileId: string) => {
        try {
            const response = await api.UserprofileApi.listUserAvatars(profileId);
            const avatarList = response.data.avatars || [];
            setAvatars(avatarList);
            const activeAvatar = avatarList.find((a: AvatarDto) => a.is_active) || avatarList[0];
            if (activeAvatar) {
                const url = await getAvatarUrl(profileId, activeAvatar.id!);
                setActiveAvatarUrl(url);
            }
        } catch (err) {
            setAvatars([]);
        }
    };

    const getAvatarUrl = async (profileId: string, avatarId: string): Promise<string> => {
        try {
            // Используем правильный подход для бинарных данных
            const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8080';
            const avatarUrl = `${baseUrl}/api/v1/userprofile/${profileId}/avatars/${avatarId}`;
            
            const response = await axios.get(avatarUrl, {
                responseType: 'blob',
                headers: {
                    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
                },
            });

            const blob = new Blob([response.data], { 
                type: response.headers['content-type'] || 'image/png' 
            });
            return URL.createObjectURL(blob);
        } catch {
            return '/default-avatar.png';
        }
    };

    const handleAvatarUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file || !profile?.id) return;

        try {
            setIsUpdating(true);
            await api.UserprofileApi.createAvatar(profile.id, file);
            // Reload avatars to update the list and activeAvatarUrl
            await loadAvatars(profile.id);

            toast({
                title: t('profile.avatarUploaded'),
                status: 'success',
                duration: 3000,
            });
        } catch (err: any) {
            console.error('Error uploading avatar:', err);
            toast({
                title: t('profile.avatarUploadError'),
                description: err.message,
                status: 'error',
                duration: 5000,
            });
        } finally {
            setIsUpdating(false);
        }
    };

    const handleSetActiveAvatar = async (avatarId: string) => {
        if (!profile?.id) return;

        try {
            await api.UserprofileApi.setActiveAvatar(profile.id, avatarId);
            // Reload avatars to update activeAvatarUrl
            await loadAvatars(profile.id);

            toast({
                title: t('profile.avatarSet'),
                status: 'success',
                duration: 3000,
            });
        } catch (err: any) {
            console.error('Error setting avatar:', err);
            toast({
                title: t('profile.avatarSetError'),
                description: err.message,
                status: 'error',
                duration: 5000,
            });
        }
    };

    const handleDeleteAvatar = async (avatarId: string) => {
        if (!profile?.id) return;

        try {
            await api.UserprofileApi.deleteAvatar(profile.id, avatarId);
            await loadAvatars(profile.id);
            await loadProfile(); // Обновляем профиль на случай если это был активный аватар

            toast({
                title: t('profile.avatarDeleted'),
                status: 'success',
                duration: 3000,
            });
        } catch (err: any) {
            console.error('Error deleting avatar:', err);
            toast({
                title: t('profile.avatarDeleteError'),
                description: err.message,
                status: 'error',
                duration: 5000,
            });
        }
    };

    // Wrapper to open Manage Avatars modal with lazy loading
    const handleManageAvatarsOpen = async () => {
        if (profile?.id) {
            await loadAvatarsIfNeeded(profile.id);
        }
        onAvatarOpen();
    };

    const handleAvatarClick = async (avatar: AvatarDto, index?: number) => {
        if (profile?.id) {
            await loadAvatarsIfNeeded(profile.id);
        }
        const avatarUrl = await getAvatarUrl(profile!.id!, avatar.id!);
        setActiveAvatarUrl(avatarUrl);
        if (typeof index === 'number') {
            // Implement avatar click logic
        }
        onViewAvatarOpen();
    };

    const navigateToNextAvatar = async () => {
        // Implement next avatar navigation logic
    };

    const navigateToPrevAvatar = async () => {
        // Implement previous avatar navigation logic
    };

    const setCurrentAvatarAsActive = async () => {
        // Implement setting current avatar as active logic
    };

    const handleSetProfileAsActive = async () => {
        if (!profile?.id || !userId) return;

        try {
            setIsUpdating(true);
            const request: SetDefaultUserProfileRequest = {
                profile_id: profile.id,
            };
            await api.UserprofileApi.setDefaultUserProfile(userId, request);

            toast({
                title: t('profile.profileActivated'),
                description: t('profile.profileActivatedDesc'),
                status: 'success',
                duration: 3000,
                isClosable: true,
            });

            // Redirect to home page to refresh active profile
            navigate('/');
        } catch (err: any) {
            console.error('Error setting profile as active:', err);
            toast({
                title: t('profile.profileActivationError'),
                description: err.message,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setIsUpdating(false);
        }
    };

    const getContactTypeIcon = (type: string) => {
        switch (type?.toLowerCase()) {
            case 'email':
                return '📧';
            case 'phone':
                return '📱';
            case 'telegram':
                return '📞';
            case 'discord':
                return '💬';
            case 'instagram':
                return '📷';
            case 'twitter':
                return '🐦';
            default:
                return '📄';
        }
    };

    const getContactDisplayName = (type: string) => {
        switch (type?.toLowerCase()) {
            case 'email':
                return t('profile.email');
            case 'phone':
                return t('profile.phone');
            case 'telegram':
                return t('profile.telegram');
            case 'discord':
                return t('profile.discord');
            case 'instagram':
                return t('profile.instagram');
            case 'twitter':
                return t('profile.twitter');
            default:
                return type;
        }
    };

    const activeAvatar = avatars.find(a => a.is_active) || avatars[0];

    // Handle contact updates
    const handleContactUpdated = () => {
        if (profile?.id) {
            loadContacts(profile.id);
        }
    };

    const handleContactDeleted = () => {
        if (profile?.id) {
            loadContacts(profile.id);
        }
    };

    // Lazy loading of profiles list
    const loadProfilesListIfNeeded = async () => {
        if (!isOwnProfile || profilesList.length > 0 || !userId) return;
        try {
            const listRes = await api.UserprofileApi.listUserProfiles(userId, 100, 0);
            setProfilesList(listRes.data.profiles || []);
        } catch (err) {
            console.error('Failed to load profiles list', err);
        }
    };

    console.log('ProfilePage: Render state', {
        profile: profile?.id,
        avatarsCount: avatars.length,
        activeAvatar: activeAvatar?.id,
        isLoading,
        error
    });

    if (isLoading) {
        return (
            <Container maxW="6xl" py={8}>
                <VStack spacing={8}>
                    <Spinner size="xl" />
                    <Text>{t('profile.loading')}</Text>
                </VStack>
            </Container>
        );
    }

    if (!profile) {
        return (
            <Container maxW="6xl" py={8} bg="bg.canvas">
                <Card bg="bg.surface">
                    <CardBody>
                        <VStack spacing={6} py={8}>
                            <Heading size="lg">{t('profile.createProfile')}</Heading>
                            <Text color="text.muted" textAlign="center">
                                {t('profile.noProfilesFound')}
                            </Text>
                            <Button
                                colorScheme={colorSchemes.primary}
                                onClick={() => navigate('/profile/create')}
                            >
                                {t('profile.createProfile')}
                            </Button>
                        </VStack>
                    </CardBody>
                </Card>
            </Container>
        );
    }

    return (
        <Container maxW="6xl" py={8} bg="bg.canvas">
            {error && (
                <Alert status="error" mb={6}>
                    <AlertIcon />
                    {error}
                </Alert>
            )}

            <Grid templateColumns={{ base: '1fr', md: '300px 1fr' }} gap={6}>
                {/* Left Column - Avatar and Basic Info */}
                <VStack spacing={4}>
                    <Card bg={"bg.surface"} w="full" border="1px solid" borderColor="border.default">
                        <CardBody>
                            <VStack spacing={4}>
                                {/* Avatar */}
                                <Box position="relative">
                                    {(profile.active_avatar_id || activeAvatar) ? (
                                        <CachedAvatar
                                            avatar={activeAvatar}
                                            avatarId={profile.active_avatar_id}
                                            profileId={profile.id!}
                                            size="2xl"
                                            onClick={() => {
                                                if (activeAvatar) {
                                                    handleAvatarClick(activeAvatar, avatars.findIndex(a => a.is_active));
                                                } else if (profile.active_avatar_id) {
                                                    // Fallback: construct minimal avatar object
                                                    handleAvatarClick({ id: profile.active_avatar_id } as AvatarDto);
                                                }
                                            }}
                                        />
                                    ) : (
                                        <Avatar
                                            size="2xl"
                                            name={profile.display_name || `${profile.first_name} ${profile.last_name}`}
                                        />
                                    )}
                                    {isOwnProfile && (
                                        <IconButton
                                            aria-label="Upload avatar"
                                            icon={<CameraIcon />}
                                            size="sm"
                                            colorScheme={colorSchemes.primary}
                                            borderRadius="full"
                                            position="absolute"
                                            bottom="0"
                                            right="0"
                                            onClick={handleManageAvatarsOpen}
                                        />
                                    )}
                                </Box>

                                {/* Name */}
                                <VStack spacing={1} textAlign="center">
                                    <Heading size="md">
                                        {profile.display_name || `${profile.first_name} ${profile.last_name}`}
                                    </Heading>
                                    {profile.bio && (
                                        <Text fontSize="sm" color={"text.muted"} noOfLines={3}>
                                            {profile.bio}
                                        </Text>
                                    )}
                                </VStack>

                                {/* Status Badge */}
                                <Badge
                                    colorScheme={profile.is_banned ? colorSchemes.error : colorSchemes.success}
                                    variant="subtle"
                                >
                                    {profile.is_banned ? t('profile.banned') : t('profile.active')}
                                </Badge>

                                {/* Action Buttons */}
                                <VStack spacing={2} w="full">
                                    {isOwnProfile ? (
                                        <>
                                            <Button
                                                leftIcon={<EditIcon />}
                                                colorScheme={colorSchemes.primary}
                                                variant="outline"
                                                size="sm"
                                                w="full"
                                                onClick={() => navigate(`/profile/edit/${profile.id}#contacts`)}
                                            >
                                                {t('profile.editProfile')}
                                            </Button>

                                            {!isActiveProfile && (
                                                <Button
                                                    leftIcon={<CheckIcon />}
                                                    colorScheme={colorSchemes.success}
                                                    size="sm"
                                                    w="full"
                                                    onClick={handleSetProfileAsActive}
                                                    isLoading={isUpdating}
                                                    loadingText={t('profile.activating')}
                                                >
                                                    {t('profile.makeActive')}
                                                </Button>
                                            )}

                                            <Button
                                                leftIcon={<SettingsIcon />}
                                                variant="ghost"
                                                size="sm"
                                                w="full"
                                            >
                                                {t('profile.settings')}
                                            </Button>
                                        </>
                                    ) : (
                                        <Button
                                            leftIcon={<ChevronLeftIcon />}
                                            colorScheme={colorSchemes.secondary}
                                            variant="outline"
                                            size="sm"
                                            w="full"
                                            onClick={() => navigate('/profiles')}
                                        >
                                            {t('common.backToProfiles')}
                                        </Button>
                                    )}
                                </VStack>
                            </VStack>
                        </CardBody>
                    </Card>
                </VStack>

                {/* Right Column - Detailed Info */}
                <VStack spacing={6} align="stretch">
                    {/* Basic Information */}
                    <Card bg={"bg.surface"} border="1px solid" borderColor="border.default">
                        <CardBody>
                            <VStack spacing={4} align="stretch">
                                <HStack justify="space-between">
                                    <Heading size="md">{t('profile.basicInfo')}</Heading>
                                    {isOwnProfile && (
                                        <Button
                                            leftIcon={<EditIcon />}
                                            size="sm"
                                            variant="ghost"
                                            colorScheme={colorSchemes.primary}
                                            onClick={() => navigate(`/profile/edit/${profile.id}`)}
                                        >
                                            {t('profile.edit')}
                                        </Button>
                                    )}
                                </HStack>
                                <Divider />

                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                                    <Box>
                                        <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.firstName')}
                                        </Text>
                                        <Text>{profile.first_name || t('common.unknown')}</Text>
                                    </Box>

                                    <Box>
                                        <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.lastName')}
                                        </Text>
                                        <Text>{profile.last_name || t('common.unknown')}</Text>
                                    </Box>

                                    {profile.middle_name && (
                                        <Box>
                                            <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                                {t('profile.middleName')}
                                            </Text>
                                            <Text>{profile.middle_name}</Text>
                                        </Box>
                                    )}

                                    <Box>
                                        <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.gender')}
                                        </Text>
                                        <Text>{profile.gender || t('common.unknown')}</Text>
                                    </Box>

                                    {profile.date_of_birth && (
                                        <Box>
                                            <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                                {t('profile.dateOfBirth')}
                                            </Text>
                                            <Text>{new Date(profile.date_of_birth).toLocaleDateString()}</Text>
                                        </Box>
                                    )}

                                    <Box>
                                        <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.language')}
                                        </Text>
                                        <Text>{profile.language || t('common.unknown')}</Text>
                                    </Box>

                                    {profile.location && (
                                        <Box>
                                            <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                                {t('profile.location')}
                                            </Text>
                                            <Text>{profile.location}</Text>
                                        </Box>
                                    )}

                                    <Box>
                                        <Text fontSize={"sm"} fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.timezone')}
                                        </Text>
                                        <Text>{profile.timezone || t('common.unknown')}</Text>
                                    </Box>
                                </SimpleGrid>
                            </VStack>
                        </CardBody>
                    </Card>

                    {/* Contacts */}
                    {(contacts.length > 0 || isOwnProfile) && (
                        <Card bg={"bg.surface"} border="1px solid" borderColor="border.default">
                            <CardBody>
                                <VStack spacing={4} align="stretch">
                                    <HStack justify="space-between">
                                        <Heading size="md">{t('profile.contacts')}</Heading>
                                        {isOwnProfile && (
                                            <Button
                                                leftIcon={<EditIcon />}
                                                size="sm"
                                                variant="ghost"
                                                colorScheme={colorSchemes.primary}
                                                onClick={() => navigate(`/profile/edit/${profile.id}#contacts`)}
                                            >
                                                {t('profile.manageContacts')}
                                            </Button>
                                        )}
                                    </HStack>
                                    <Divider />

                                    {isLoadingContacts ? (
                                        <VStack py={8}>
                                            <Spinner />
                                            <Text color="text.muted">{t('profile.loadingContacts')}</Text>
                                        </VStack>
                                    ) : contacts.length > 0 ? (
                                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                                            {contacts.map((contact) => (
                                                <ContactCard
                                                    key={contact.id}
                                                    contact={contact}
                                                    entity={{ type: 'userprofile', id: profile?.id }}
                                                    isEditable={isOwnProfile}
                                                    onContactUpdated={handleContactUpdated}
                                                    onContactDeleted={handleContactDeleted}
                                                />
                                            ))}
                                        </SimpleGrid>
                                    ) : (
                                        <VStack spacing={4} py={8}>
                                            <Text color={"text.muted"} textAlign="center">
                                                {isOwnProfile ? t('profile.noContactsOwn') : t('profile.noContactsOther')}
                                            </Text>
                                            {isOwnProfile && (
                                                <Button
                                                    leftIcon={<EditIcon />}
                                                    size="sm"
                                                    colorScheme={colorSchemes.primary}
                                                    variant="outline"
                                                    onClick={() => navigate(`/profile/edit/${profile.id}#contacts`)}
                                                >
                                                    {t('profile.addContacts')}
                                                </Button>
                                            )}
                                        </VStack>
                                    )}
                                </VStack>
                            </CardBody>
                        </Card>
                    )}

                    {/* Account Information */}
                    <Card bg={"bg.surface"} border="1px solid" borderColor="border.default">
                        <CardBody>
                            <VStack spacing={4} align="stretch">
                                <Heading size="md">{t('profile.accountInfo')}</Heading>
                                <Divider />

                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                                    <Box>
                                        <Text fontSize="sm" fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.profileId')}
                                        </Text>
                                        <Text fontSize="xs" fontFamily="mono">{profile.id}</Text>
                                    </Box>

                                    <Box>
                                        <Text fontSize="sm" fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.userId')}
                                        </Text>
                                        <Text fontSize="xs" fontFamily="mono">{profile.user_id}</Text>
                                    </Box>

                                    <Box>
                                        <Text fontSize="sm" fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.createdAt')}
                                        </Text>
                                        <Text fontSize="sm">
                                            {profile.created_at ? new Date(profile.created_at).toLocaleString() : t('common.unknown')}
                                        </Text>
                                    </Box>

                                    <Box>
                                        <Text fontSize="sm" fontWeight="semibold" color={"text.muted"}>
                                            {t('profile.updatedAt')}
                                        </Text>
                                        <Text fontSize="sm">
                                            {profile.updated_at ? new Date(profile.updated_at).toLocaleString() : t('common.unknown')}
                                        </Text>
                                    </Box>
                                </SimpleGrid>
                            </VStack>
                        </CardBody>
                    </Card>

                    {/* My Profiles Section */}
                    {isOwnProfile && (
                        <GridItem>
                            <Card h="fit-content" border="1px solid" borderColor="border.default">
                                <CardHeader>
                                    <HStack justify="space-between">
                                        <Heading size="md">My Profiles</Heading>
                                        {profilesList.length === 0 && (
                                            <Button size="xs" onClick={loadProfilesListIfNeeded}>
                                                {t('profile.showProfiles')}
                                            </Button>
                                        )}
                                    </HStack>
                                </CardHeader>
                                <CardBody>
                                    {profilesList.length === 0 ? (
                                        <Text color="text.muted" fontSize="sm">
                                            {t('profile.noProfilesLoaded')}
                                        </Text>
                                    ) : (
                                        <VStack align="stretch" spacing={3}>
                                            {profilesList.map(p => (
                                                <HStack key={p.id} justify="space-between">
                                                    <Text>{p.display_name || p.id}</Text>
                                                    {p.id === profile?.id ? (
                                                        <Badge colorScheme="green">Current</Badge>
                                                    ) : (
                                                        <Button size="xs" onClick={() => navigate(`/profile?profile=${p.id}`)}>View</Button>
                                                    )}
                                                </HStack>
                                            ))}
                                        </VStack>
                                    )}
                                </CardBody>
                            </Card>
                        </GridItem>
                    )}
                </VStack>
            </Grid>

            {/* Avatar Management Modal */}
            {isOwnProfile && (
                <Modal isOpen={isAvatarOpen} onClose={onAvatarClose} size="xl">
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{t('profile.manageAvatars')}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <VStack spacing={sectionSpacing}>
                                {/* Upload Button */}
                                <Box>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleAvatarUpload}
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                    />
                                    <Button
                                        leftIcon={<CameraIcon />}
                                        colorScheme={colorSchemes.primary}
                                        onClick={() => fileInputRef.current?.click()}
                                        isLoading={isUpdating}
                                    >
                                        {t('profile.uploadAvatar')}
                                    </Button>
                                </Box>

                                {/* Avatars Grid */}
                                {avatars.length > 0 ? (
                                    <SimpleGrid columns={3} spacing={itemSpacing} w="full">
                                        {avatars.map((avatar, index) => (
                                            <Box key={avatar.id} position="relative">
                                                <CachedAvatar
                                                    avatar={avatar}
                                                    profileId={profile.id!}
                                                    onClick={() => handleAvatarClick(avatar, index)}
                                                    borderRadius="lg"
                                                    border={avatar.is_active ? '3px solid' : '1px solid'}
                                                    borderColor={avatar.is_active ? 'blue.500' : "border.default"}
                                                    cursor="pointer"
                                                    boxSize="100px"
                                                />

                                                {avatar.is_active && (
                                                    <Badge
                                                        position="absolute"
                                                        top="2"
                                                        left="2"
                                                        colorScheme={colorSchemes.primary}
                                                        variant="solid"
                                                        fontSize="xs"
                                                    >
                                                        {t('profile.avatarActive')}
                                                    </Badge>
                                                )}

                                                <Menu>
                                                    <MenuButton
                                                        as={IconButton}
                                                        aria-label="Avatar options"
                                                        icon={<SettingsIcon />}
                                                        size="sm"
                                                        variant="solid"
                                                        colorScheme={colorSchemes.neutral}
                                                        position="absolute"
                                                        top="2"
                                                        right="2"
                                                    />
                                                    <MenuList>
                                                        {!avatar.is_active && (
                                                            <MenuItem onClick={() => handleSetActiveAvatar(avatar.id!)}>
                                                                {t('profile.makeActive')}
                                                            </MenuItem>
                                                        )}
                                                        <MenuItem
                                                            onClick={() => handleDeleteAvatar(avatar.id!)}
                                                            color="red.400"
                                                        >
                                                            {t('profile.deleteAvatar')}
                                                        </MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </Box>
                                        ))}
                                    </SimpleGrid>
                                ) : (
                                    <Text color={"text.muted"} textAlign="center">
                                        {t('profile.noAvatars')}
                                    </Text>
                                )}
                            </VStack>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={onAvatarClose}>
                                {t('common.close')}
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            )}

            {/* Avatar Viewer Modal - VK Style */}
            <Modal isOpen={isViewAvatarOpen} onClose={onViewAvatarClose} size="4xl" isCentered>
                <ModalOverlay bg="blackAlpha.800" />
                <ModalContent bg="transparent" shadow="none" maxW="90vw" maxH="90vh">
                    <ModalBody p={0} position="relative">
                        <Box position="relative" display="flex" justifyContent="center" alignItems="center">
                            <Image
                                src={activeAvatarUrl}
                                alt="Avatar"
                                maxW="100%"
                                maxH="90vh"
                                objectFit="contain"
                                borderRadius="lg"
                            />

                            {/* Navigation buttons */}
                            {avatars.length > 1 && (
                                <>
                                    <IconButton
                                        aria-label="Previous avatar"
                                        icon={<ChevronLeftIcon />}
                                        position="absolute"
                                        left="4"
                                        top="50%"
                                        transform="translateY(-50%)"
                                        colorScheme={"whiteAlpha"}
                                        variant="solid"
                                        size="lg"
                                        onClick={navigateToPrevAvatar}
                                        _hover={{ bg: 'whiteAlpha.300' }}
                                    />

                                    <IconButton
                                        aria-label="Next avatar"
                                        icon={<ChevronRightIcon />}
                                        position="absolute"
                                        right="4"
                                        top="50%"
                                        transform="translateY(-50%)"
                                        colorScheme={"whiteAlpha"}
                                        variant="solid"
                                        size="lg"
                                        onClick={navigateToNextAvatar}
                                        _hover={{ bg: 'whiteAlpha.300' }}
                                    />
                                </>
                            )}

                            {/* Close button */}
                            <IconButton
                                aria-label="Close"
                                icon={<CloseIcon />}
                                position="absolute"
                                top="4"
                                right="4"
                                colorScheme={"whiteAlpha"}
                                variant="solid"
                                size="lg"
                                onClick={onViewAvatarClose}
                                _hover={{ bg: 'whiteAlpha.300' }}
                            />

                            {/* Action buttons */}
                            <VStack
                                position="absolute"
                                bottom="4"
                                left="50%"
                                transform="translateX(-50%)"
                                spacing={smallSpacing}
                            >
                                {isOwnProfile && avatars[0] && !avatars[0].is_active && (
                                    <Button
                                        leftIcon={<CheckIcon />}
                                        colorScheme={"whiteAlpha"}
                                        variant="solid"
                                        size="sm"
                                        onClick={setCurrentAvatarAsActive}
                                        _hover={{ bg: 'whiteAlpha.300' }}
                                    >
                                        {t('profile.setAsActive')}
                                    </Button>
                                )}

                                <Text color="text.inverted" fontSize={"sm"} textAlign="center">
                                    1 / {avatars.length}
                                </Text>
                            </VStack>
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Container>
    );
}; 